<template>
  <div>
    <div class="top_tit">
      <div class="line"></div>
      <p>{{ data.Name }}</p>
    </div>
    <div class="bottom_content">
      <a class="link" href="javascript:;" @click="openUrl()">
        <dl class="survey-share flex">
          <dt>
            <van-image
              height="50"
              :src="api.FileHost + tenant.LogoSmall"
              width="50"
            />
          </dt>
          <dd class="flex flex-v flex-pack-center">
            <h4>客户档案</h4>
            <p>点击完善客户档案</p>
          </dd>
        </dl>
      </a>
    </div>
  </div>
  <OpenIframe ref="OpenIframe" />
</template>
<script>
  import store from '@/store'
  import OpenIframe from '@/components/OpenIframe'
  import api from '@/api'
  export default {
    components: {
      OpenIframe,
    },
    props: {
      data: {
        type: Object,
        default() {
          return {}
        },
      },
    },
    data() {
      return {
        api,
        tenant: {},
      }
    },
    created() {
      this.init()
    },
    methods: {
      async init() {
        this.tenant = await store.getters['user/getTenant']
      },
      async openUrl() {
        const H5Url = await store.getters['system/getH5Url']
        let url = `${H5Url}survey/#/crm/getInfo`
        this.$refs['OpenIframe'].show(url, '完善客户档案')
      },
    },
  }
</script>
<style lang="scss" scoped>
  .bottom_content {
    padding: 12px;
  }
  .link {
    display: block;
    padding: 12px;
    border: 1px solid #efefef;
    line-height: 1;
    color: #666;
    border-radius: 9px;
    dt {
      height: 50px;
    }
    dl,
    dt,
    dd {
      margin: 0;
    }
    dd {
      padding-left: 12px;
      h4 {
        font-weight: normal;
        color: #333;
        font-size: 16px;
      }
      p {
        font-size: 14px;
        color: #999;
        margin-top: 6px;
        line-height: 1.2;
      }
    }
  }
</style>
